import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { RiBillLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { ITimelineItem } from '@clients/timelineClient';
import TimelineItemTemplate from '@components/accountTimeline/accountTimelineBlock/TimelineItemTemplate';

export type TimelineItemNoTimelineProps = {
    timelineItem: ITimelineItem;
    highlightOnHover?: boolean;
    panelMode?: boolean;
};

const TimelineItemNoTimeline = ({
    timelineItem,
    highlightOnHover = false,
    panelMode = false,
}: TimelineItemNoTimelineProps) => {
    const { theme } = useTheme();

    return (
        <TimelineItemTemplate
            key={timelineItem.timestamp}
            avatar={<RiBillLine size={theme.spacing(4)} />}
            testId="timelineitem-notimeline"
            primaryTitle={
                <FormattedMessage
                    id="AccountTimeline.NoTimeline"
                    defaultMessage="No Timeline"
                />
            }
            primarySubtitle={
                <FormattedMessage
                    id="AccountTimeline.NoTimelineForThisAccount"
                    defaultMessage="No Timeline for this account"
                />
            }
            secondaryTitle=""
            secondarySubtitle=""
            urlToNavigateTo=""
            highlightOnHover={highlightOnHover}
            panelMode={panelMode}
        />
    );
};

export default TimelineItemNoTimeline;
